// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__zVLS5","footer":"style_footer__3Rg8F","copy":"style_copy__6GF-C","nav":"style_nav__Gcz2K","link":"style_link__2EqMw"};